import TextFieldComponent from '../textfield';

class EmailComponent extends TextFieldComponent {
  constructor (component, data, options) {
    super(component, data, options);
  }
}

export default EmailComponent;
